import { cn } from '@/lib/utils'
import { statusMeta, type StatusIntent } from '@/lib/orderStatus'

const INTENT_CLASS: Record<StatusIntent, string> = {
  ok: 'bg-ok/12 text-ok',
  warn: 'bg-warn/12 text-warn',
  danger: 'bg-danger/12 text-danger',
  info: 'bg-info/12 text-info',
  ship: 'bg-ship/12 text-ship',
  neutral: 'bg-paperSoft text-inkSoft',
}

/**
 * Nhãn trạng thái đơn — chấm màu + chữ, không icon.
 *
 * Đây là lối ra DUY NHẤT của `o.status` lên giao diện. Trang nào in thẳng
 * `o.status` sẽ để lọt enum thô (`dang-giao`) ra trước mặt người dùng — đúng
 * lỗi đang thấy ở bảng đơn cấp Đại lý.
 *
 * Trước đây khối này bị chép ở Overview.tsx, Orders.tsx và OrderDetail.tsx.
 */
export function StatusPill({
  status,
  className,
}: {
  status?: string | null
  className?: string
}) {
  const meta = statusMeta(status)
  return (
    <span
      data-slot="status"
      data-intent={meta.intent}
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full px-2 py-0.5 text-xs font-medium',
        INTENT_CLASS[meta.intent],
        className,
      )}
    >
      <span className="size-1.5 rounded-full bg-current" aria-hidden />
      {meta.text}
    </span>
  )
}

/** Chấm trạng thái trần — cho những chỗ chật, đã có chữ ngay bên cạnh. */
export function StatusDot({ status, className }: { status?: string | null; className?: string }) {
  const meta = statusMeta(status)
  return (
    <span
      className={cn('inline-block size-1.5 shrink-0 rounded-full', INTENT_CLASS[meta.intent], className)}
      title={meta.text}
      aria-label={meta.text}
      role="img"
    />
  )
}
